import React from 'react';
import { Outlet } from 'react-router-dom';
import { DateRangeProvider } from '../../contexts/DateRangeContext';
import { AgentFilterProvider } from '../../contexts/AgentFilterContext';
import { AgentLabelsProvider } from '../../contexts/AgentLabelsContext';
import { AgentServiceProvider } from '../../contexts/AgentServiceContext';
import customAgentsService from '../../services/custom-agents/customAgentsService';
import {
  CUSTOM_AGENTS_CAPABILITIES,
  CUSTOM_AGENTS_LABELS,
  CUSTOM_AGENTS_MODULE,
  CustomAgentsModuleProvider,
} from './customAgentsModule';

const MODULE_CONTEXT = Object.freeze({
  ...CUSTOM_AGENTS_MODULE,
  capabilities: CUSTOM_AGENTS_CAPABILITIES,
});

/**
 * Provider boundary for the namespaced Custom Agents routes — the counterpart
 * of GeminiAgentsLayout.
 *
 * Every shared context gets a Custom value here so nothing inside can fall back
 * to a Gemini default: the service context would otherwise hand shared pages
 * the Gemini Enterprise API, and the date range would share Gemini's
 * sessionStorage entry. Pages that bring their own adapter (Intent Analysis,
 * Compliance) still wrap themselves, and the inner provider wins.
 */
const CustomAgentsLayout = ({ children }) => (
  <CustomAgentsModuleProvider value={MODULE_CONTEXT}>
    <AgentLabelsProvider value={CUSTOM_AGENTS_LABELS}>
      <AgentServiceProvider value={customAgentsService}>
        <DateRangeProvider storageKey="custom_agents_date_range">
          <AgentFilterProvider storageKey="custom_agents_filters">
            {children ?? <Outlet />}
          </AgentFilterProvider>
        </DateRangeProvider>
      </AgentServiceProvider>
    </AgentLabelsProvider>
  </CustomAgentsModuleProvider>
);

export default CustomAgentsLayout;
